module.exports = __webpack_public_path__ + "static/media/meta-image-default.edefc7df.jpg";